<template>
  <v-card
      class="grey lighten-3"
  >
    <v-card-title>
      Dokumenty ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          :Volunteer="Volunteer"
          @refresh="refresh"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.createdAtFrom"
                        :error-messages="errors.Filters && errors.Filters.createdAtFrom"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Dátum nahratia od"
                        type="date"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.createdAtTo"
                        :error-messages="errors.Filters && errors.Filters.createdAtTo"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Dátum nahratia do"
                        type="date"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.type"
                        :error-messages="errors.Filters && errors.Filters.type"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Typ"
                        :items="$store.getters['register/getDocumentType']"
                        no-data-text="Žiadne výsledky"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        <a
                            @click="setOrder($store.state.register.Document.Filter.order['createdAt'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.Document.Filter.order['createdAt'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.Document.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Dátum a čas nahratia
                        </a>
                      </th>

                      <th
                          class="fixed"
                      >
                        Súbor
                      </th>

                      <th>
                        Typ
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="documents.length > 0"
                    >
                      <tr
                          v-for="Document in documents"
                          :key="Document.id"
                      >
                        <td>
                          {{ new Date(Document.createdAt)|dateFormat('DD.MM.YYYY HH:mm') }}
                        </td>

                        <td
                            class="fixed"
                        >
                          <a
                              @click="downloadFileByLink(loadLinkByPath('files/generate/pdf/' + Document.File.token))"
                          >
                            {{ Document.File.name }}
                          </a>
                        </td>

                        <td>
                          {{ $store.state.register.Document.type[Document.type].text }}
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <Delete
                              :icon="true"
                              :id="Document.id"
                              @refresh="refresh"
                              @init="init"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="4"
                            class="text-center"
                        >
                          Nenašli sa žiadne dokumenty.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getDocumentFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Documents from '@/services/documents'

  import Create from '@/components/Documents/Create'
  import Delete from '@/components/Documents/Delete'

  export default {
    name: 'Documents',
    props: [
      'Volunteer'
    ],
    components: {
      Create,
      Delete
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        documents: [],
        params: {
          Filters: {
            createdAtFrom: '',
            createdAtTo: ''
          },
          order: this.$store.state.register.Document.Filter.order['createdAt'].value,
          by: this.$store.state.register.Document.Filter.by['DESC'].value,
          limit: this.$store.state.register.Document.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      refresh() {
        setTimeout(() => {
          this.$emit('refresh')
        }, 1000)
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Document.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Document.Filter.by['DESC'].value

            break

          case this.$store.state.register.Document.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Document.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      loadData() {
        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Documents
          .indexVolunteer({
            volunteerId: this.Volunteer.id,
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.documents = response.data.data.documents

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 403:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      },
      downloadFileByLink(link) {
        window.open(link)
      }
    }
  }
</script>
